import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/hocs/withValidUrl';
import { NoSidebarLayout } from '@public/components/Layouts/NoSidebarLayout';
import { PageWrapper } from '@public/components/Layouts/PageWrapper';
import { LoginPage as Login } from '@public/components/User/Auth/Pages/Login';
import type { GetServerSideProps } from 'next';

const LoginPage = (props: IGenericPageProps) => {
  const { currentSite } = props?.siteData || {};
  const canonicalURL = `https://www.on3.com${currentSite?.url}/join/`;
  const title = `${currentSite?.name} Login | On3.com`;

  return (
    <PageWrapper {...props} canonical={canonicalURL} hideAds title={title}>
      <NoSidebarLayout>
        <Login />
      </NoSidebarLayout>
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      pageType: 'user',
      siteData: siteData || [],
      userData: userData || {},
    },
  };
};

export default withValidUrl(LoginPage);
